import { IBlock, IListMessageBlock } from 'common/builder/blocks/blockInterfaces'
import { BlockType } from 'common/builder/constants/BlockType'

export function isListMessageBlock(block: IBlock): block is IListMessageBlock {
  return block.type === BlockType.WA_LIST_MESSAGE
}
